import React from "react";
import { useDurationFilter, DurationFilterType } from "../context/DurationFilterContext";
import "./DurationSelector.css";

export default function DurationSelector() {
  const { duration, setDuration } = useDurationFilter();

  const options: { value: DurationFilterType; label: string }[] = [
    { value: 1, label: "1 day" },
    { value: 3, label: "3 days" },
    { value: 7, label: "7 days" },
    { value: 30, label: "30 days" },
  ];

  return (
    <div className="time-range-group">
      {options.map((option) => (
        <label key={option.value} className="time-chip">
          <input
            type="radio"
            name={`duration-${Math.random()}`} // ensure unique name if multiple selectors are used
            value={option.value}
            checked={duration === option.value}
            onChange={() => setDuration(option.value)}
          />
          {option.label}
        </label>
      ))}
    </div>
  );
}
